import React, { useEffect, useState } from "react";
import { SecureImageProps } from "../../service/interfaces/Components";

const SecureImage: React.FC<SecureImageProps> = ({
  bucketName = "motosop-files",
  fileKey,
  alt = "Secure Image",
  width = "32.21px",
  className = "",
  style
}) => {
  const [imageUrl, setImageUrl] = useState<string>("");

  useEffect(() => {
    const buildGcpUrl = () => {
      try {
        const baseUrl = process.env.REACT_APP_GCP_BUCKET_URL || "https://storage.googleapis.com/motosop-files";
        const fullUrl = `${baseUrl}/${fileKey}`;
        setImageUrl(fullUrl);
      } catch (error) {
        console.error("Error building GCP URL:", error);
      }
    };

    if (fileKey) {
      buildGcpUrl();
    }
  }, [bucketName, fileKey]);

  return <img src={imageUrl} alt={alt} width={width} className={className} style={style} />;
};

export default SecureImage;
